<template>
    <div>
       
        <form-wizard color="#B1D06C" :title="null" :subtitle="null" shape="square" finish-button-text="Submit"
            back-button-text="Previous" class="mb-3" @on-complete="formSubmitted" ref="formWiz">
            <!-- Search customer tab -->
      
            <tab-content title="Chosen Customer">
                <SelectCustomer :leadClientId="serviceOne.leadClientId" />
            </tab-content>
            <tab-content title="Chosen Service">
                <SelectTemplate  :serviceId="serviceOne.itemId" />
            </tab-content>
            <tab-content title="Modify your template">
                <b-container class="text-center">
                    <TemplateView :templateId="serviceOne" @onchange="template" />
                </b-container>
            </tab-content>
            <tab-content title="Modify Price & Submit">
                <Price :product="serviceOne" @price="price" />
            </tab-content>

        </form-wizard>
    </div>
</template>
  
<script>
import SelectCustomer from './selectCustomer.vue'
import SelectTemplate from './SelectTemplate.vue'
import TemplateView from './TemplateView.vue'
import Price from './Price.vue'
import { FormWizard, TabContent } from "vue-form-wizard";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { BRow, BCol, BButton } from "bootstrap-vue";
import { codeIcon } from "./LeadsWizard.js";
import { mapGetters, mapActions } from "vuex";

export default {
    components: {
        FormWizard,
        BButton,
        SelectCustomer,
        SelectTemplate,
        TemplateView,
        Price,
        TabContent,
        BRow,
        BCol,
        ToastificationContent,
    },
    data() {
        return {
            codeIcon,
            customerId: "",
            templateId: "",
            templateData: {
                name: null,
                startDate: null,
                dueDate: null,
                assignedTo: null,
                template: null,
            },
            templatePrice: {
                salePrice: null,
                additionalCost: null,
            }
        };
    },
    computed: {
        ...mapGetters("productModule", {
            productID: "productID",
            loading: "loading",
        }),

        ...mapGetters("serviceModule", {
            serviceOne: "serviceOne",
            loading: "loading",
        }),
    },
    async mounted() {
       
        await this.getServiceRequestsByIDAction(this.$route.params.id);
    },
    methods: {
        ...mapActions("productModule", ["getProductIDAction"]),
        ...mapActions("serviceModule", ["addServiceRequestsAction", "getServiceRequestsByIDAction", "updateServiceRequestAction"]),

        customerSelected(customerSelected) {
            this.customerId = customerSelected;
        },
      
        template(template) {
            console.log(template);

            this.templateData.name = template.name;
            this.templateData.startDate = template.startDate;
            this.templateData.dueDate = template.dueDate;
            this.templateData.assignedTo = template.assignedTo;
            this.templateData.template = template.template;
        },

        price(price) {
            this.templatePrice.salePrice = price.NewPrice;
            this.templatePrice.additionalCost = parseFloat(price.additionalCost);
        },
        formSubmitted() {

   
            let payload = {
                id: this.serviceOne.id,
                name: this.templateData.name,
                startDate: this.templateData.startDate,
                dueDate: this.templateData.dueDate,
                assignedTo: this.templateData.assignedTo,
                status: 0,
                totalCost: this.templatePrice.salePrice,
                salePrice: this.templatePrice.salePrice,
                additionalCost: this.templatePrice.additionalCost,
                leadClientId: this.serviceOne.leadClientId,
                itemId: this.serviceOne.itemId,
                notes: this.serviceOne.notes,
                template: this.templateData.template,
                isActive: true,
            };
            this.updateServiceRequestAction(payload)
                .then(() => {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: "Service Request Added",
                            icon: "EditIcon",
                            variant: "success",
                        },
                        
                    }),
                    this.$router.push({ name: "request-list" });
                })
                .catch((error) => {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: "Service Request Not Added" + error.response.data.message,
                            icon: "EditIcon",
                            variant: "danger",
                        },
                    });
                    this.$router.push({ name: "request-list" });
                });
        },
    },
};
</script>
  
<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
  